import { useState } from "react";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import { useToastHandler } from "../../../common/ToastHandler";

const BiometricCheckController = () => {
  const { Post } = useApi();
  const { handleToast } = useToastHandler();

  // Enrollment form fields
  const [machineIdEnroll, setMachineIdEnroll] = useState("");
  const [fingerprintIdEnroll, setFingerprintIdEnroll] = useState("");
  const [enroll, setEnroll] = useState(false);

  // Biometric log form fields
  const [machineIdLog, setMachineIdLog] = useState("");
  const [fingerprintIdLog, setFingerprintIdLog] = useState("");

  // Enrollment states
  const [loadingEnroll, setLoadingEnroll] = useState(false);
  const [resultEnroll, setResultEnroll] = useState(null);
  const [errorEnroll, setErrorEnroll] = useState("");

  // Log states
  const [loadingLog, setLoadingLog] = useState(false);
  const [resultLog, setResultLog] = useState(null);
  const [errorLog, setErrorLog] = useState("");

  const resetForm = () => {
    setMachineIdEnroll("");
    setFingerprintIdEnroll("");
    setMachineIdLog("");
    setFingerprintIdLog("");
    setResultEnroll(null);
    setResultLog(null);
    setErrorEnroll("");
    setErrorLog("");
    setEnroll(false);
  };

  // ENROLLMENT HANDLER — Only for enrollment when enroll checkbox is checked
  const handleEnrollment = (e) => {
    e.preventDefault();
    setLoadingEnroll(true);
    setErrorEnroll("");
    setResultEnroll(null);

    // Check if enroll checkbox is checked
    if (!enroll) {
      setErrorEnroll("Please check the 'Enroll' checkbox to enroll a fingerprint.");
      handleToast({ 
        type: "ERROR", 
        message: "Please check the 'Enroll' checkbox to enroll a fingerprint." 
      });
      setLoadingEnroll(false);
      return;
    }

    const payload = {
      machine_id: machineIdEnroll,
      fingerprint_id: fingerprintIdEnroll,
      enroll: true, // Always true for enrollment
    };

    Post("checkBiometric", payload)
      .then((response) => {
        setResultEnroll(response);
        const successMsg = response?.message || "Enrolled successfully!";
        handleToast({ type: "SUCCESS", message: successMsg });
        // Clear fields after success with a short delay
        setTimeout(() => {
          resetForm();
        }, 1000);
      })
      .catch((err) => {
        const msg =
          err?.response?.data?.error ||
          err?.response?.data?.message ||
          err.message ||
          "Something went wrong";
        setErrorEnroll(msg);
        handleToast({ type: "ERROR", message: msg });
      })
      .finally(() => setLoadingEnroll(false));
  };

  // BIOMETRIC LOG/CHECK HANDLER — Only for attendance logging
  const handleBiometricLogs = (e, action) => {
    e.preventDefault();
    setLoadingLog(true);
    setErrorLog("");
    setResultLog(null);
    
    const payload = {
      machine_id: machineIdLog,
      fingerprint_id: fingerprintIdLog,
      action, // This will be "IN" or "OUT"
    };

    Post("checkBiometric", payload)
      .then((response) => {
        setResultLog(response);
        const successMsg = response?.message || `Attendance ${action} logged successfully!`;
        handleToast({
          type: "SUCCESS",
          message: successMsg,
        });
        // Clear fields after success with a short delay
        setTimeout(() => {
          resetForm();
        }, 1000);
      })
      .catch((err) => {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          err.message ||
          "Something went wrong";
        setErrorLog(msg);
        handleToast({ type: "ERROR", message: msg });
      })
      .finally(() => setLoadingLog(false));
  };

  return {
    // Enrollment fields
    machineIdEnroll,
    setMachineIdEnroll,
    fingerprintIdEnroll,
    setFingerprintIdEnroll,
    enroll,
    setEnroll,

    // Biometric log fields
    machineIdLog,
    setMachineIdLog,
    fingerprintIdLog,
    setFingerprintIdLog,

    // Enrollment states and handler
    loadingEnroll,
    resultEnroll,
    errorEnroll,
    handleEnrollment,

    // Log states and handler
    loadingLog,
    resultLog,
    errorLog,
    handleBiometricLogs,

    resetForm,
  };
};

export default BiometricCheckController;